import { render } from "./OurServicesMainPageSmallScreen.vue?vue&type=template&id=282af7e6"
import script from "./OurServicesMainPageSmallScreen.vue?vue&type=script&lang=js"
export * from "./OurServicesMainPageSmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__